class Directory extends HTMLElement {
  constructor(){
    super();

    this.input = this.querySelector('nav input[type="search"]');
    this.slider = this.querySelector('[data-slider]');
    this.mediaQuery = window.matchMedia("(min-width: 769px)");

    this.initSlider();
    this.initSearch();
  }

  initSlider() {
    if (!this.slider) return;

    let options = {
      freeScroll: true,
      contain: true,
      groupCells: true,
      pageDots: false,
      cellAlign: this.mediaQuery.matches ? 'left' : 'right'
    }

    new Flickity(this.slider, options);

    this.mediaQuery.addEventListener('change', (e) => {
      const flkty = Flickity.data(this.slider);
      flkty.options.cellAlign = e.matches ? 'left' : 'right';
      flkty.resize();
      flkty.reposition();
    });
  }

  initSearch() {
    if (!this.input) return;

    const container = this.querySelector('section dl');
    const instance = new Mark(container);

    this.input.addEventListener("input", (e) => {
      instance.unmark();

      let value = e.target.value;
      if (value && value.trim().length > 0){
        container.classList.add('is-searching');

        value = value.trim().toLowerCase();
        instance.mark(value, {
          "exclude": ["dt"]
        });
      } else {
        container.classList.remove('is-searching');
      }
    });
  }
}

if (!customElements.get('brands-directory')) {
  customElements.define('brands-directory', Directory);
}
